import { render, staticRenderFns } from "./Dynamics.vue?vue&type=template&id=e90c1902&scoped=true&"
import script from "./Dynamics.vue?vue&type=script&lang=ts&"
export * from "./Dynamics.vue?vue&type=script&lang=ts&"
import style0 from "./Dynamics.vue?vue&type=style&index=0&id=e90c1902&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90c1902",
  null
  
)

export default component.exports